<template>
  <div class="">
    <div v-if="config.public.MERCHANT == 'dis88'">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="pagination" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in dis88CardData">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="my-2 mx-4 sm:m-2 md:pl-7 pt-3">
                <img :src="data?.image" :alt="data?.heading" class="w-[75px] sm:w-[100px]" />
              </div>
              <h1 class="px-4 pb-2 sm:py-3 text-lg sm:text-2xl pl-6 md:pl-10 text-[#fff]">
                {{ data.heading }}
              </h1>
              <p class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.description }}
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <iframe class="rounded-2xl pt-5" width="100%" height="315"
        src="https://www.youtube.com/embed/FyIVSZNLtAI?si=bz1cC-frWfp75X4D" title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>

    <div v-if="['jw8','uea8','wic11'].includes(config.public.MERCHANT) && getCurrentCurrency != 'SGD' && !(['jw8'].includes(config.public.MERCHANT) && ['BDT','THB'].includes(getCurrentCurrency))">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="pagination" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in jw8CardData">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="flex items-center md:block">
                <div class="md:my-2 mx-4 sm:m-2 md:pl-7 md:pt-3">
                  <img :src="data?.image" :alt="data?.heading" class="w-[50px] md:w-[75px]" />
                </div>
                <h1 class="md:px-4 md:pb-2 sm:py-3 text-lg sm:text-2xl md:pl-10 text-[#fff]">
                  {{ data.heading }}
                </h1>
              </div>
              <p class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.description }}
              </p>
              <p v-if="data.descriptionFriend && data.descriptionRefer" class="px-4 pt-1 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.descriptionFriend }}
              </p>
              <p v-if="data.descriptionFriend && data.descriptionRefer" class="px-4 pb-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.descriptionRefer }}
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe v-if="dashboardStore.ready && dashboardStore.data && dashboardStore.data.currency == 'MYR'"
                class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video_MYR" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
     <div v-if="config.public.MERCHANT == 'jw8' && getCurrentCurrency == 'BDT'">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in jw8CardDataBdt" :key="index">
          <div class="tutorial-content w-[100%] mt-5 flex flex-col md:flex-row rounded-xl">
            <div class="mt-5 w-[100%] flex-2 md:w-[40%] rounded-2xl tutorial-content-detail-container">
                <h1 class="px-4 pb-2 sm:py-3 text-lg sm:text-2xl pl-6 md:pl-7 text-[#fff]" 
                v-html="locale === 'bn-bd' ? data.bn_title: data.en_title">
                </h1>
                <p class="px-2 py-2 mb-2 text-[13px] sm:text-sm pl-[25px] md:pl-7 text-[#fff]" 
                v-html="locale === 'bn-bd' ? data.bn_description : data.en_description">
                </p>
            </div>
            <div class="w-full flex-3 md:w-[60%] rounded-1xl overflow-hidden md:ml-4">
              <iframe class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="locale === 'bn-bd' ? data.bn_video : data.en_video" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div v-if="config.public.MERCHANT == 'jw8' && getCurrentCurrency == 'SGD'">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="paginationSgd" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in jw8CardDataSgd">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="flex items-center md:block">
                <div class="md:my-2 mx-4 sm:m-2 md:pl-7 md:pt-3">
                  <img :src="data?.image" :alt="data?.heading" class="w-[50px] md:w-[75px]" />
                </div>
                <h1 class="md:px-4 md:pb-2 sm:py-3 text-lg sm:text-2xl md:pl-10 text-[#fff]">
                  {{ data.heading }}
                </h1>
              </div>
              <p v-if="!(data.descriptionFriend && data.descriptionRefer)" class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.description }}
              </p>
              <p v-if="data.descriptionFriend && data.descriptionRefer" class="px-4 pt-1 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.descriptionFriend }}
              </p>
              <p v-if="data.descriptionFriend && data.descriptionRefer" class="px-4 pb-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.descriptionRefer }}
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe v-if="locale == 'en-sg'"
                class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video_SGD" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
              <iframe v-else
                class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video_SGDC" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div v-if="config.public.MERCHANT == 'jw8' && getCurrentCurrency == 'THB'">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="paginationSgd" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in jw8CardDataThb">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="flex items-center md:block">
                <div class="md:my-2 mx-4 sm:m-2 md:pl-7 md:pt-3">
                  <img :src="data?.image" :alt="data?.heading_en" class="w-[50px] md:w-[75px]" />
                </div>
                <h1 class="md:px-4 md:pb-2 sm:py-3 text-lg sm:text-2xl md:pl-10 text-[#fff]" 
                v-html="locale === 'en-th' ? data.heading_en: data.heading_th">
                </h1>
              </div>
              <p class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]"
               v-html="locale === 'en-th' ? data.description_en: data.description_th">
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe
                class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="locale === 'en-th' ? data.video_en : data.video_th" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>


    <div v-if="config.public.MERCHANT == 'cambo8' && getCurrentCurrency == 'SGD'">
      <iframe class="rounded-2xl pt-5" width="100%" height="315" src="https://www.youtube.com/embed/LYXNyMNV42A?si=7AV_mVDSdo4_HPFr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>

    <div v-if="config.public.MERCHANT == 'cambo8' && getCurrentCurrency == 'USD'">
      <iframe class="rounded-2xl pt-5" width="100%" height="315" src="https://www.youtube.com/embed/HeSH3LLE0eA?si=5JWh64xZBLHk8DVo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>

    <div v-if="config.public.MERCHANT == 'jolibet'">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="pagination" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in jolibetCardData">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="my-2 mx-4 sm:m-2 md:pl-7 pt-3">
                <img :src="data?.image" :alt="data?.heading" class="w-[75px] sm:w-[100px]" />
              </div>
              <p class="px-4 pb-2 sm:py-3 text-lg xl:text-2xl pl-6 md:pl-10 text-[#fff]">
                {{ data.heading }}
              </p>
              <p class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[80%] 2xl:w-[80%] text-[#fff]">
                {{ data.description }}
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>

    <div v-if="config.public.MERCHANT == 'ime88'">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="pagination" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in ime88CardData">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="my-2 mx-3 sm:m-2 md:pl-7 pt-3">
                <img :src="data?.image" :alt="data?.heading" class="w-[75px] sm:w-[100px]" />
              </div>
              <h1 class="px-4 pb-2 sm:py-0 text-lg sm:text-2xl pl-6 md:pl-10 text-[#fff]">
                {{ data.heading }}
              </h1>
              <p class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]" v-html="data.description"></p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe v-if="mainStore.lang == 'en'" class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video_en" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
              <iframe v-else class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video_ne" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>

    <div v-if="config.public.MERCHANT == 'ew8'">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="paginationEw8" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in ew8CardData" :key="index">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="flex items-center md:block">
                <div class="md:my-2 mx-4 sm:m-2 md:pl-7 md:pt-3">
                  <img v-if="data.card == '1' || data.card == '3'" :src="data?.image" :alt="data?.heading" class="w-[50px] md:w-[75px]" />
                  <div class="mt-4 md:mt-2" v-else v-html="data?.image"></div>
                </div>
                <h1 class="md:px-4 md:pb-2 sm:py-3 text-lg sm:text-2xl md:pl-10 text-[#fff]">
                  {{ data.heading }}
                </h1>
              </div>
              <p class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.description }}
              </p>
              <p v-if="data.card == '3'" class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.tutorialDescription }}
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe v-if="dashboardStore.ready && dashboardStore.data"
                class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video_MYR" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>

    <div v-if="config.public.MERCHANT == 'goat77' && (['en-my', 'ms-my', 'zh-my', 'en-sg','zh-sg'].includes(locale))">
      <!-- <iframe  class="rounded-2xl" width="100%" height="315"
        src="https://www.youtube.com/embed/NEW8doWZ0yk?si=z8KJoulIQkmD6RWA" title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
        
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="paginationGoat77" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in goat77Card">
          <div class="tutorial-content w-[100%] mt-5 flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl tutorial-content-detail-container">
              <div class="my-2 mx-4 sm:m-2 md:pl-7 pt-3 md:mt-7">
                <img v-if="['icon-sign-up-bonus', 'icon-deposit', 'icon-withdrawal'].includes(data?.icon)" :src="$pub(data?.imgSrc)" :alt="data?.heading" class="w-[75px] sm:w-[100px]" />
                <Icon v-else :iconClass="`${data.icon} text-[75px] sm:w-[100px]`"></Icon>
              </div>
              <h1 class="px-4 pb-2 sm:py-3 text-lg sm:text-2xl pl-6 md:pl-10 text-[#fff] text-center">
                {{ data.heading }}
              </h1>
              <p class="px-2 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#fff]">
                {{ data.description }}
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
               :src="['en-my', 'en-sg'].includes(locale) ? data.en_video : locale == 'ms-my' ? data.bm_video : data.cn_video" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <!-- Click Zones -->
    </div>

    <!-- FR-10151 -->
    <div v-if="config.public.MERCHANT == 'uf9' && (['en-my', 'ms-my', 'zh-my'].includes(locale))">
      <!-- <iframe class="rounded-2xl" width="100%" height="315"
        src="https://www.youtube.com/embed/NEW8doWZ0yk?si=z8KJoulIQkmD6RWA" title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->

      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="paginationuf9" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in uf9Card">
          <div class="tutorial-content w-[100%] mt-5 flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl tutorial-content-detail-container">
              <div class="my-2 mx-4 sm:m-2 md:pl-7 pt-5 md:mt-7">
                  <Icon :iconClass="`${data?.icon} text-[60px]`"></Icon>
              </div>
                <h1 class="px-4 pb-2 sm:py-3 text-lg sm:text-2xl pl-6 md:pl-7 text-[#fff]">
                  {{ data.heading }}
                </h1>
                <p class="px-2 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-7 xl:w-[80%] 2xl:w-[90%] text-[#fff]" v-html="data.description"></p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="locale == 'en-my' ? data.en_video : locale == 'ms-my' ? data.bm_video : data.cn_video" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <!-- Click Zones -->
    </div>
      <div v-if="config.public.MERCHANT == 'm3'  && (['en-my', 'ms-my', 'zh-my'].includes(locale))">
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="paginationm3" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in m3Card">
          <div class="tutorial-content w-[100%] flex flex-col md:flex-row rounded-xl">
            <div class="md:mt-11 mt-[4.5rem] w-[100%] flex-2 md:w-[40%] rounded-2xl">
              <div class="flex items-center md:block">
                <div class="my-2 mx-4 sm:m-2 md:pl-7 pt-3">
                  <!-- <img :src="data?.image" :alt="data?.heading" class="w-[75px] sm:w-[100px]" /> -->
                </div>
                <h1 class="md:px-4 md:pb-2 sm:py-3 text-lg sm:text-2xl md:pl-10 text-[#000]">
                  {{ locale == 'en-my' ? data.heading_EN : locale == 'ms-my' ? data.heading_MY : data.heading_ZH }}
                </h1>
              </div>
              <p class="px-4 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-[42px] xl:w-[70%] 2xl:w-[65%] text-[#000] sm:mt-3 sm:mb-2" v-html="locale == 'en-my' ? data.description_EN : locale == 'ms-my' ? data.description_MY : data.description_ZH">
              </p>
            </div>
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden">
              <iframe v-if="dashboardStore.ready && dashboardStore.data && dashboardStore.data.currency == 'MYR'"
                class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="data.video_EN" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <!-- FR-11174 -->
    <div v-if="config.public.MERCHANT == '8mbets' && ['en-np', 'ne-np'].includes(locale)">
      <Swiper :slides-per-view="1" :auto-height="true" :space-between="30" :centered-slides="true"
        :pagination="paginationmbets" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in mbetsCard" :key="index">
          <div class="tutorial-content w-[100%] mt-5 flex flex-col md:flex-row rounded-xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl tutorial-content-detail-container">
              <div class="my-2 mx-4 sm:m-2 md:pl-7 pt-5 md:mt-7">
                  <Icon :iconClass="`${data?.icon} text-[60px] text-[#000]`"></Icon>
              </div>
                <h1 class="px-4 pb-2 sm:py-3 text-lg sm:text-2xl pl-6 md:pl-7 text-[#000]" 
                v-html="locale === 'ne-np' ? data.ne_title: data.en_title">
                </h1>
                <p class="px-2 py-2 mb-2 text-[13px] sm:text-sm pl-[25px] md:pl-7 text-[#000]" 
                v-html="locale === 'ne-np' ? data.ne_description : data.en_description">
                </p>
            </div>
            <div class="w-full flex-3 md:w-[60%] rounded-1xl overflow-hidden md:ml-4">
              <iframe class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="locale === 'ne-np' ? data.ne_video : data.en_video" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>

    <!-- FR-10920 -->
     <div v-if="['mw99'].includes(config.public.MERCHANT) && (['en-np', 'ne-np'].includes(locale))">
        
      <Swiper :slides-per-view="1" :auto-height="true" space-between="30" :centeredSlides="true"
        :pagination="paginationmw99" :modules="modules" @slideChange="onSlideChange" class="tutorial">
        <SwiperSlide v-for="(data, index) in mw99Card">
          <div class="tutorial-content w-[100%] mt-5 flex flex-col md:flex-row rounded-2xl">
            <div class="mt-11 w-[100%] flex-2 md:w-[40%] rounded-2xl tutorial-content-detail-container">
              <div class="my-2 mx-4 sm:m-2 md:pl-7 pt-5 md:mt-7">
                  <Icon :iconClass="`${data?.icon} text-[60px]`"></Icon>
              </div>
                <h1 class="px-4 pb-2 sm:py-3 text-lg sm:text-2xl pl-6 md:pl-7 text-[#fff]">
                  {{ data.heading }}
                </h1>
                <p class="px-2 py-2 text-[13px] sm:text-sm pl-[25px] md:pl-7 xl:w-[80%] 2xl:w-[90%] text-[#fff]">
                  {{ data.description }}
                </p>
            </div> 
            <div class="w-[100%] flex-3 md:w-[60%] rounded-2xl overflow-hidden tutorial-video-container">
              <iframe class="tutorial-iframe rounded-2xl h-full tutorial-video" width="100%" height="100%"
                :src="locale == 'en-np' ? data.en_video : data.np_video" title="Steamable video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen :id="`player-${index}`">
              </iframe>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <!-- Click Zones -->
    </div>
     
  </div>
</template>

<script setup>
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from "swiper/vue";
import { Navigation, Pagination, Autoplay } from "swiper";
import tutorialDepositImage from "/img/tutorial_deposit.webp";
import tutorialWithdrawImage from "/img/tutorial_withdraw.webp";
import tutorialReferralImage from "/img/icon-referral.webp";
const { locale, locales } = useI18n()
const localePath = useLocalePath()

const dashboardStore = useDashboardStore();
const mainStore = useMainStore()
const config = useRuntimeConfig();
const { $pub, $getCurrency, $categoryName } = useNuxtApp();
const { t } = useI18n();
const { isMobile, isIos, isAndroid } = useDevice();
const modules = [Pagination, Navigation, Autoplay];
const pagination = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let icon;
    if (index === 0) {
      label = "deposit";
      icon = $pub("/img/icons_svg/icon-tutorial-deposit.webp");
    } else if (index === 1) {
      label = "withdrawal";
      icon = $pub("/img/icons_svg/icon-tutorial-withdrawal.webp");
    }else if (index === 2) {
      label = "referral";
      icon = tutorialReferralImage;
    }
    return `<span class=" ${className} flex">
                        <img class="w-[25px] pr-2" src="${icon}" alt="label-icon"/>
                        ${t(label)}
                    </span>`;
  },
};

const paginationSgd = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let icon;
    if (index === 0) {
      label = "deposit";
      icon = $pub("/img/icons_svg/icon-tutorial-deposit.webp");
    } else if (index === 1) {
      label = "withdrawal";
      icon = $pub("/img/icons_svg/icon-tutorial-withdrawal.webp");
    } else if (index === 2) {
      label = "referral";
      icon = tutorialReferralImage;
    }
    return `<span class=" ${className} flex">
                        <img class="w-[25px] pr-2" src="${icon}" alt="label-icon"/>
                        ${t(label)}
                    </span>`;
  },
};

// FR-9517 THIS PAGINATION IS FOR EW8 MERCHANT
const paginationEw8 = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let iconHtml;

    if (index === 0) {
      label = "deposit";
      iconHtml = `<i class="icon-deposit w-[25px] pr-2">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    } else if (index === 1) {
      label = "register";
      iconHtml = `<i class="icon-sign-in-task w-[25px] pr-2">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    } else if (index === 2) {
      label = "withdraw";
      iconHtml = `<i class="icon-withdrawal w-[25px] pr-2">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }

    return `<span class="${className} flex items-center">
              ${iconHtml}
              ${t(label)}
            </span>`;
  },
};

// FR-9389 THIS PAGINATION IS FOR EW8 MERCHANT
const paginationGoat77 = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let iconHtml;

    if (index === 0) {
      label = "deposit";
      iconHtml = `<img class="w-[35px] px-2" src="${$pub("/img/icons/icons_png/icon-tutorial-deposit.webp")}" alt="icon-tutorial-deposit"/>`;
    } else if (index === 1) {
       label = "withdraw";
      iconHtml = `<img class="w-[35px] px-2" src="${$pub("/img/icons/icons_png/icon-tutorial-withdrawal.webp")}" alt="icon-tutorial-withdrawal"/>`;
    }
    else if (index === 2) {
      label = "register";
      iconHtml = `<img class="w-[35px] px-2" src="${$pub("/img/icons/icons_png/icon-tutorial-register.webp")}" alt="icon-tutorial-register"/>`;
    }

    return `<span class="${className} flex items-center">
              ${iconHtml}
              ${t(label)}
            </span>`;
  },
};

const paginationuf9 = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let iconHtml;
    if (index === 0) {
      label = "sponsorship";
      iconHtml = `<i class="icon-partnership w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }
    else if (index === 1) {
      label = "sports";
      iconHtml = `<i class="icon-sport w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }
    else if (index === 2) {
      label = "register";
      iconHtml = `<i class="icon-sign-in-task w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    } else if (index === 3) {
      label = "deposit";
      iconHtml = `<i class="icon-deposit w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }
    else if (index === 4) {
      label = "referral";
      iconHtml = `<i class="icon-referral w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }

    return `<span class="${className} flex items-center">
              ${iconHtml}
              ${t(label)}
            </span>`;
  },
};

const paginationmbets = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let iconHtml;
    if (index === 0) {
      label = "brand ambassador";
      iconHtml = `<i class="icon-referral w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }
    else if (index === 1) {
      label = "join now";
      iconHtml = `<i class="icon-sign-in-task w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }
    else if (index === 2) {
      label = "GAME JACKPOT";
      iconHtml = `<i class="icon-esport w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }

    return `<span class="${className} flex items-center">
              ${iconHtml}
              ${label}
            </span>`;
  },
};

const paginationmw99 = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let iconHtml;
    if (index === 0) {
      label = "deposit";
      iconHtml = `<i class="icon-deposit w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }
    else if (index === 1) {
      label = "register";
      iconHtml = `<i class="icon-sign-in-task w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    } else if (index === 2) {
      label = "withdraw";
      iconHtml = `<i class="icon-withdrawal w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }
    else if (index === 3) {
      label = "referral";
      iconHtml = `<i class="icon-referral w-[25px] pr-2 text-[18px]">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
          <span class="path7"></span>
          <span class="path8"></span>
          <span class="path9"></span>
          <span class="path10"></span>
          <span class="path11"></span>
          <span class="path12"></span>
          <span class="path13"></span>
        </i>`;
    }

    return `<span class="${className} flex items-center">
              ${iconHtml}
              ${t(label)}
            </span>`;
  },
};

const paginationm3 = {
  clickable: true,
  renderBullet: function (index, className) {
    let label;
    let icon;
    if (index === 0) {
      label = "DJ Soda";
      // icon = $pub("/img/icons_svg/icon-tutorial-deposit.webp");
    } else if (index === 1) {
      label = "Roman Reigns";
      // icon = $pub("/img/icons_svg/icon-tutorial-withdrawal.webp");
    }
    return `<span class=" ${className} flex">
                        ${label}
                    </span>`;
  },
};

const dis88CardData = [
  {
    image: tutorialDepositImage,
    video: "https://www.youtube.com/embed/cM9cKP6PyV8?enablejsapi=1",
    heading: t("deposit_video_tutorial"),
    description: t("deposit_description"),
  },
  {
    image: tutorialWithdrawImage,
    video: "https://www.youtube.com/embed/i6TL5BUzjR8?enablejsapi=1",
    heading: t("withdrawal_video_tutorial"),
    description: t("withdraw_description"),
  },
];

const ime88CardData = [
  {
    image: tutorialDepositImage,
    video_en: "https://www.youtube.com/embed/wDgSYQo6RCs?si=8De4CLvzd8tfddvb",
    video_ne: "https://www.youtube.com/embed/4DbvCyQNOwY?si=ksbjsGQy5ZhTaY8H",
    heading: t("deposit_video_header"),
    description: t("deposit_video_description"),
  },
  {
    image: tutorialWithdrawImage,
    video_en: "https://www.youtube.com/embed/YzGXU49Py5A?si=h_GldXpYHVD-hrMD",
    video_ne: "https://www.youtube.com/embed/TVSeTZ4aVL4?si=E7VheqKGLF4C009g",
    heading: t("withdrawal_video_header"),
    description: t("withdrawal_video_description"),
  },
  {
    image: tutorialReferralImage,
    video_en: "https://www.youtube.com/embed/Xe5h32PZxbQ?si=XL4YM7faR2Bo0jZS",
    video_ne: "https://www.youtube.com/embed/vVWsDPOWmxc?si=8_vGv_TSgkd5O38o",
    heading: t("referral_video_header"),
    description: t("referral_video_description"),
  },
];

const jw8CardData = [
  {
    image: tutorialDepositImage,
    video_MYR: "https://www.youtube.com/embed/PcKU-xIKRXc?si=wRSRROjdCV8bvXWR",
    heading: t("how_to_deposit"),
    description: t("effortlessly_manage_your_deposits_at_JW8_watch_this_video_tutorial_and_learn_the_simple_steps"),
  },
  {
    image: tutorialWithdrawImage,
    video_MYR: "https://www.youtube.com/embed/dT04Afollbc?si=nsSHIT1UWP8GtAXo",
    heading: t("how_to_withdraw"),
    description: t("money_withdrawals_at_JW8_are_super_easy_Watch_this_video_tutorial_and_learn_the_simple_steps"),
  },
  {
    image: tutorialReferralImage,
    video_MYR: "https://www.youtube.com/embed/CsTj6_5Jhms?si=-GXpQFYqNM2NYwJ5" ,
    heading: t("how_to_do_referral"),
    descriptionFriend: t("refer_your_friends_CN"),
    descriptionRefer: t("now_are_super_easy_Watch_this_video_tutorial_and_learn_the_simple_steps_CN"),
  },
];
const jw8CardDataSgd = [
  {
    image: tutorialDepositImage,
    video_SGD: "https://www.youtube.com/embed/DOJiOXNu9q0",
    video_SGDC: "https://www.youtube.com/embed/DOJiOXNu9q0",
    heading: t("how_to_deposit"),
    description: t("effortlessly_manage_your_deposits_at_JW8_watch_this_video_tutorial_and_learn_the_simple_steps"),
  },
  {
    image: tutorialWithdrawImage,
    video_SGD: "https://www.youtube.com/embed/EPxGf3WX8kw",
    video_SGDC: "https://www.youtube.com/embed/EPxGf3WX8kw",
    heading: t("how_to_withdraw"),
    description: t("money_withdrawals_at_JW8_are_super_easy_Watch_this_video_tutorial_and_learn_the_simple_steps"),
  },
  {
    image: tutorialReferralImage,
    video_SGD: "https://www.youtube.com/embed/ub1UvSb_m4U",
    video_SGDC: "https://www.youtube.com/embed/ub1UvSb_m4U",
    heading: t("how_to_referral"),
    descriptionFriend: t("refer_your_friends"),
    descriptionRefer: t("now_are_super_easy_Watch_this_video_tutorial_and_learn_the_simple_steps"),
  },
];

const jw8CardDataThb = [
  {
    image: tutorialDepositImage,
    video_th: "https://www.youtube.com/embed/mcAEccupgE8?si=BFW3bXF_-NbnWGp3",
    video_en: "https://www.youtube.com/embed/PcKU-xIKRXc?si=PE0hmZr54Il2-Ab1",
    heading_en: "How to Deposit Money",
    heading_th: " วิธีการฝากเงิน",
    description_en: "Deposit money into JW8 easily! Just click and watch this tutorial video!",
    description_th: "ฝากเงิน JW8 ด้วยวิธีการง่าย ๆ เพียงคลิกดูวิดีโอแนะนำนี้!",
  },
  {
    image: tutorialWithdrawImage, 
    video_th: "https://www.youtube.com/embed/F06Wstkd1Pc?si=hlKPoKwr2By_9bsf",
    video_en: "https://www.youtube.com/embed/dT04Afollbc?si=NeKVyQxT_CfHWB-_",
    heading_en: "How to Withdraw Money",
    heading_th: "วิธีการถอนเงิน",
    description_en: "Withdrawing money at JW8 is very easy! Watch this tutorial video and learn the simple steps.",
    description_th: "การถอนเงินที่ JW8 ง่ายมาก! ดูวิดีโอแนะนำนี้และเรียนรู้ขั้นตอนง่าย ๆ",
  },
  {
    image: tutorialReferralImage,
    video_th: "https://www.youtube.com/embed/mny41fUGAGs?si=olKde48c3K46oYS9",
    video_en: "https://www.youtube.com/embed/CsTj6_5Jhms?si=ORQ36YTM0F4RJync",
    heading_en: "How to Refer a Friend",
    heading_th: "วิธีการแนะนำ",
    description_en: "Refer your friends now!<br /> Referrals are very easy! Watch this tutorial video and learn the simple steps.",
    description_th: "แนะนำเพื่อนของคุณเลย! การแนะนำนั้นง่ายมาก! ดูวิดีโอแนะนำนี้และเรียนรู้ขั้นตอนง่าย ๆ",
  },
];

const jw8CardDataBdt = [
  {
    en_title: "JW8 Viral App in Asia?! 238% New User Rewards + Hidden Rewards Inside!",
    en_description: `
      <span>
        🚀 The app that’s going viral across Asia right now — JW8<br /><br />
        Everyone is talking about this fast-growing mobile gaming platform. <br /><br />
        So… what makes JW8 so popular? <br /><br />

        ✨ Key Highlights: <br />
        🎮 Access to 10,000+ games in one app <br />
        ⚡️ Fast, smooth & user-friendly experience <br />
        🎯 Wide variety of interactive game categories <br />
        📱 Seamless mobile experience anytime, anywhere <br />
        📅 Daily check-in surprises & new user rewards <br />
        👥 Invite friends & unlock extra earning opportunities <br /><br />

        No complicated steps. Just a simple and smooth experience that keeps users coming back. <br /><br />

        🔥 This is why JW8 is trending across Asia right now. <br />

        👉 Try it yourself and see why everyone is talking about it.<br />

      </span>
    `,
    en_video: "https://www.youtube.com/embed/_2tlUTv_qi8?si=2iExZ1ZD_v29h__i",

    bn_title: "এশিয়ায় ভাইরাল JW8 অ্যাপ?! ২৩৮% নতুন ইউজার রিওয়ার্ড + ভেতরে লুকানো সারপ্রাইজ রিওয়ার্ড!",
    bn_description: `
      <span>
        🚀 এশিয়া জুড়ে এখন যে অ্যাপটা ভাইরাল — JW8<br /><br />

        সবাই এখন এই দ্রুত জনপ্রিয় হয়ে ওঠা মোবাইল গেমিং প্ল্যাটফর্মের কথা বলছে।<br /><br />

        তাহলে… JW8 এত জনপ্রিয় কেন?<br /><br />

        ✨ মূল হাইলাইটস:<br />

        🎮 এক অ্যাপেই ১০,০০০+ গেমে অ্যাক্সেস<br />
        ⚡️ দ্রুত, স্মুথ ও ইউজার-ফ্রেন্ডলি এক্সপেরিয়েন্স<br />
        🎯 ইন্টারঅ্যাকটিভ গেম ক্যাটাগরির বড় ভ্যারাইটি<br />
        📱 যেকোনো সময়, যেকোনো জায়গায় স্মুথ মোবাইল এক্সপেরিয়েন্স<br />
        📅 ডেইলি চেক-ইন সারপ্রাইজ ও নতুন ইউজার রিওয়ার্ড<br />
        👥 বন্ধু ইনভাইট করুন & বাড়তি আয়ের সুযোগ আনলক করুন<br /><br />

        কোনো জটিল ধাপ নেই। সহজ আর স্মুথ অভিজ্ঞতাই সবাইকে বারবার ফিরিয়ে আনে।<br /><br />

        🔥 এ কারণেই JW8 এখন এশিয়া জুড়ে ট্রেন্ডিং।<br />

        👉 নিজে ট্রাই করে দেখুন—কেন সবাই কথা বলছে বুঝে যাবেন।

      </span>
    `,
    bn_video: "https://www.youtube.com/embed/_2tlUTv_qi8?si=2iExZ1ZD_v29h__i",
  }
  ]

const jolibetCardData = [
  {
    image: tutorialDepositImage,
    video: "https://www.youtube.com/embed/qCjnrNdYSuY?si=HUCPUMHRjwiye9po",
    heading: t("easy_deposit_guide"),
    description: t("easy_deposit_guide_desc"),
  },
  {
    image: tutorialWithdrawImage,
    video: "https://www.youtube.com/embed/vRMM_3A9k-Y?si=FAm-6TZTe6w5fYlB",
    heading: t("withdraw_video_tutorial"),
    description: t("withdraw_video_tutorial_desc"),
  },
  {
    image: tutorialReferralImage,
    video: "https://www.youtube.com/embed/o7OAtvvub30?si=yJwk505PxNXIf_K_",
    heading: t("referral_video_tutorial"),
    description: t("referral_video_tutorial_desc"),
  },
];

// THIS ARRAY OBJECT FOR EW8 MERCHANT 


// THIS OPTIONS ARE FOR GOAT77 MERCHANT
const goat77Card = [
  {
    icon: 'icon-deposit',
    imgSrc: '/img/icons/icons_png/icon-tutorial-deposit.webp',
    heading: t("deposit_tutorial_2"),
    description: t("deposit_tutorial_desc_goat77"),
    en_video:  'https://www.youtube.com/embed/pczBWoid9aA?si=Xp5ldQtK8Kryw-pd',
    cn_video:  'https://www.youtube.com/embed/kkd-oVyF1XY?si=j5bIZPkRNUDJJW_X',
    bm_video: "https://www.youtube.com/embed/seymlqrhm_E?si=_Kc9CqeVhFXLDphN",
  },
  {
    icon: 'icon-withdrawal',
    imgSrc: '/img/icons/icons_png/icon-tutorial-withdrawal.webp',
    heading: t("withdrawal_tutorial"),
    description: t("withdrawal_tutorial_desc_goat77"),
    en_video:  'https://www.youtube.com/embed/YJ1zwB87LOg?si=yqCr0Yaw70LUIiFB' ,
    cn_video:  'https://www.youtube.com/embed/5eXWn7_BP28?si=os2k76OxHlGITv-n',
    bm_video: "https://www.youtube.com/embed/o8wVZZkdlVw?si=tmNZSHD3JBJ8iBB1",
  },
  {
    icon: 'icon-sign-up-bonus',
    imgSrc: '/img/icons/icons_png/icon-tutorial-register.webp',
    heading: t("register_tutorial"),
    description: t("register_tutorial_desc_goat77"),
    en_video:  'https://www.youtube.com/embed/m4SZ4Ydm9FU?si=PtTQFa7nfIP0hG0r',
    cn_video:  'https://www.youtube.com/embed/52N7DexxaXI?si=mlSfeezFylUhjJcP',
    bm_video:  "https://www.youtube.com/embed/4R_Fu3izyzE?si=1gU8Y7iEGISTJOMA",
  },
];


// THIS OPTIONS ARE FOR UF9 MERCHANT REGARDING FR-10151
  const uf9Card = [
  {
    icon: 'icon-partnership',
    heading: t("how_to_sponsor"),
    description: t("how_to_sponsor_desc_uf9"),
    en_video: "https://www.youtube.com/embed/v9ae8GICQwY",
    cn_video: "https://www.youtube.com/embed/v9ae8GICQwY",
    bm_video: "https://www.youtube.com/embed/v9ae8GICQwY",
  },
  {
    icon: 'icon-sport',
    heading: t("why_uf9_sports"),
    description: `<span>
              ${t("unmatched_odds_uf9")} <br/>
              ${t("real_time_uf9")} <br/>
              ${t("global_coverage_uf9")} <br/>
              ${t("trusted_certified_uf9")} <br/><br/>
              ${t("platform_sports_desc_uf9")}
            </span>`,
    en_video: "https://www.youtube.com/embed/S2khMnwZvsY",
    cn_video: "https://www.youtube.com/embed/S2khMnwZvsY",
    bm_video: "https://www.youtube.com/embed/S2khMnwZvsY",
  },
  {
    icon: 'icon-sign-in-task',
    heading: t("how_to_register_become_member"),
    description: t("how_to_register_desc_uf9"),
    en_video: "https://www.youtube.com/embed/JXjTvEIidIQ?si=FR-Dha0u8IKJTYTR",
    cn_video: "https://www.youtube.com/embed/2SZ_36Wzb9U?si=ISB7RR58rAB15qec",
    bm_video: "https://www.youtube.com/embed/-Yd6e-VRfck?si=ZbUTUpDhC0ilj4CC",
  },
  {
    icon: 'icon-deposit',
    heading: t("how_to_deposit_and_play_game"),
    description: t("how_to_deposit_desc_uf9"),
    en_video: "https://www.youtube.com/embed/BG5WAG-A7Y4?si=MffE5IvoZOYsRvMw",
    cn_video: "https://www.youtube.com/embed/L0BowcgrOrs?si=dv3FuqrgSa5mjBJL",
    bm_video: "https://www.youtube.com/embed/h9ECtFA8KIQ?si=-AKBBk1mTjM1gLNW",
  },
  {
    icon: 'icon-referral',
    heading: t("how_to_referral_friend_join"),
    description: t("how_to_referral_desc_uf9"),
    en_video: "https://www.youtube.com/embed/PmKPU2oNhOA?si=8ajIa_ORQI8m662b",
    cn_video: "https://www.youtube.com/embed/uEHg7wQVP6I?si=0diK8RUUylmrbkbb",
    bm_video: "https://www.youtube.com/embed/eFmVD4xRJj0?si=hzD4IHI09VytKrJb",
  }];

const m3Card = [
{
    video_EN: "https://www.youtube.com/embed/1WFDjQ0zs_A?si=dsx9SQ1YaPAlvkfA",
    video_MY: "https://www.youtube.com/embed/K1AK-ovLgsw?si=ofVXKgW0paGOe6_t",
    video_ZH: "https://www.youtube.com/embed/YnSc1Q48IKc?si=8Qd-NyHO9JtKJ861",
    heading_EN :'Bet Never Stop "ALL IN ALL IN " Official MV',
    heading_MY :'Taruhan Penuh Gairah “ALL IN ALL IN” MV Rasmi',
    heading_ZH :'激情下注 “ALL IN ALL IN” 官方MV',
    description_EN: `<span>Starts Betting at M3 Today🔥 <br />
                     Bet Never Stop – “ALL IN ALL IN” Official MV is now LIVE! <br />
                     Feel the high-stakes energy and electrifying beats with M3 x DJ Soda 2026 🎧💥 Turn up the volume, go ALL IN, and feel the rush.</span>`,
    description_MY: `<span>Mulakan taruhan anda di M3 hari ini, rasai kegembiraan tanpa had! <br />
                     MV Rasmi “ALL IN ALL IN” kini TERSIAR! 🔥 <br />
                     Ikuti irama M3 x DJ Soda 2026, rasai keseronokan ekstrem dan hentakan muzik elektronik! 🎧💥Hidupkan volume, ALL IN sepenuhnya, dan nikmati pengalaman penuh adrenalin yang belum pernah dirasai sebelum ini!</span>`,
    description_ZH: `<span>今天就来M3下注，尽情狂热！ <br />
                     ”ALL IN ALL IN” 官方MV震撼上线🔥 <br />
                     跟随M3 x DJ Soda 2026的节奏，感受极限刺激与电音冲击！🎧💥 开大音量，全力ALL IN，享受前所未有的激情体验！</span>`,
    card: 1
  },
  {
    video_EN: "https://www.youtube.com/embed/sLmNGfZI9pM?si=HN66EkkFiZBxeJ52",
    video_MY: "https://www.youtube.com/embed/K1AK-ovLgsw?si=ofVXKgW0paGOe6_t",
    video_ZH: "https://www.youtube.com/embed/YnSc1Q48IKc?si=8Qd-NyHO9JtKJ861",
    heading_EN :'M3 Brand Ambassador Roman Reigns 2026',
    heading_MY :'Duta Jenama M3 Roman Reigns 2026',
    heading_ZH :'M3 品牌大使 罗曼·雷恩斯 2026',
    description_EN: `<span>Don’t bet to prove it, you bet to own it. <br />
                     M3 crowns the true DOMINATORS, champions hit in a flash, bet leads the way! ✅<br />
                     This is OUR reign, just like Roman Reign in a GAME.<br />
                     🎯Win BIG. Stay SAFE. Play at Own RANGE. </span>`,
    description_MY: `<span>Bertaruh bukan untuk membuktikan diri, tetapi untuk menguasai segalanya!<br />
                     M3 menobatkan penguasa sejati, juara menyerang dalam sekelip mata, taruhan mengawal permainan! ✅ <br />
                     Ini adalah pemerintahan kami, seperti Roman Reigns yang menguasai gelanggang!<br />
                     🎯 Menang BESAR, main bijak, semuanya di bawah kawalan anda!</span>`,
    description_ZH: `<span>下注，不为证明，只为统治全局！<br />
                     M3 加冕真·主宰，冠军瞬间出击，下注掌控全局！✅ <br />
                     这是我们的统治，就像罗曼·雷恩斯称霸擂台！<br />
                     🎯 赢大钱，稳操作，尽在你掌控！</span>`,
    card: 1
  },
];


const mbetsCard = [
  {
    icon: 'icon-referral',
    en_title: "JOIN 8MBets NOW",
    en_description: `
      <span>
        CLAIM Your BONUS and HIT Your JACKPOT NOW! <br />
        ☘️ Easy Win | Easy Life ☘️ <br /><br />

        Ready to WIN BIG? <br />
        🎰 Don’t wait—JOIN 8MBets NOW and unlock a world of unbeatable bonuses, exciting games, and non-stop action! Whether you're a seasoned player or just getting started, 8MBets is your ultimate destination to play, win, and cash out with ease! <br /><br />
        👉 SIGN UP instantly and CLAIM your exclusive WELCOME BONUS! <br />
        👉 SPIN, BET, and WIN on your favorite slots, live casinos, and sports bets. <br />
        👉 LEVEL UP with daily rewards, cashback offers, and thrilling tournaments.
      </span>
    `,
    en_video: "https://youtube.com/embed/qEcItD-FaYY?feature=share",

    ne_title: "JOIN 8MBets NOW",
    ne_description: `
      <span>
        CLAIM Your BONUS and HIT Your JACKPOT NOW! <br />
        ☘️ Easy Win | Easy Life ☘️ <br /><br />

        Ready to WIN BIG? <br />
        🎰 Don’t wait—JOIN 8MBets NOW and unlock a world of unbeatable bonuses, exciting games, and non-stop action! Whether you're a seasoned player or just getting started, 8MBets is your ultimate destination to play, win, and cash out with ease! <br /><br />
        👉 SIGN UP instantly and CLAIM your exclusive WELCOME BONUS! <br />
        👉 SPIN, BET, and WIN on your favorite slots, live casinos, and sports bets. <br />
        👉 LEVEL UP with daily rewards, cashback offers, and thrilling tournaments.
      </span>
    `,
    ne_video: "https://youtube.com/embed/qEcItD-FaYY?feature=share",
  },
  {
    icon: 'icon-sign-in-task',
    en_title: "ANKITA DAVE ❤️ LOVES ❤️ 8MBets",
    en_description: `
      <span>
        MOST TRUSTED NEPAL ONLINE i-GAMING <br />
        | Real Game | Fast Response | 24/7 customer Support | <br />
        JOIN NOW! <br /><br />

        💖 Why does Ankita Dave love 8MBets? <br />
        Because we deliver what players want: <br />
        ✅ Real Games with real chances to win <br />
        ✅ Instant Deposit & Withdrawal options <br />
        ✅ 24/7 Live Support that’s always got your back <br /
        ✅ Massive Jackpots and thrilling tournaments
      </span>
    `,
    en_video: "https://youtube.com/embed/unHuwsjxA3w?feature=share",

    ne_title: "ANKITA DAVE ❤️ LOVES ❤️ 8MBets",
    ne_description: `
      <span>
        MOST TRUSTED NEPAL ONLINE i-GAMING <br />
        | Real Game | Fast Response | 24/7 customer Support | <br />
        JOIN NOW! <br /><br />

        💖 Why does Ankita Dave love 8MBets? <br />
        Because we deliver what players want: <br />
        ✅ Real Games with real chances to win <br />
        ✅ Instant Deposit & Withdrawal options <br />
        ✅ 24/7 Live Support that’s always got your back <br />
        ✅ Massive Jackpots and thrilling tournaments
      </span>
    `,
    ne_video: "https://youtube.com/embed/unHuwsjxA3w?feature=share",
  },
  {
    icon: 'icon-esport',
    en_title: "Be The Winner of 8MBets",
    en_description: `
      <span>
        HIT Your JACKPOT NOW! <br />
        ☘️ Easy Win | Easy Life ☘️ <br /><br />

        🎉 Want to be the next big winner? Now is your chance! <br />
        Join 8MBets TODAY and take the first step toward a life of excitement, rewards, and non-stop winning! <br />
        Whether you're into slots, sports betting, live casino, or table games—8MBets has it all! <br />
        ⚡️ ACT NOW - Every second you wait is a jackpot you could miss. <br />
        🔥 PLAY SMART, bet wisely, and CASH OUT BIG! <br />
        💸 Don't just watch others win—BECOME the winner. <br />
        🌟 Take control of your game and transform your free time into real rewards.
      </span>
    `,
    en_video: "https://youtube.com/embed/F_lYHGrR6II?feature=share",

    ne_title: "Be The Winner of 8MBets",
    ne_description: `
      <span>
        HIT Your JACKPOT NOW! <br />
        ☘️ Easy Win | Easy Life ☘️ <br /><br />

        🎉 Want to be the next big winner? Now is your chance! <br />
        Join 8MBets TODAY and take the first step toward a life of excitement, rewards, and non-stop winning! <br />
        Whether you're into slots, sports betting, live casino, or table games—8MBets has it all! <br />
        ⚡️ ACT NOW - Every second you wait is a jackpot you could miss. <br />
        🔥 PLAY SMART, bet wisely, and CASH OUT BIG! <br />
        💸 Don't just watch others win—BECOME the winner. <br />
        🌟 Take control of your game and transform your free time into real rewards.
      </span>
    `,
    ne_video: "https://youtube.com/embed/F_lYHGrR6II?feature=share",
  }
];

// THIS OPTIONS ARE FOR MW99 MERCHANT REGARDING FR-10920

const mw99Card = [
  {
    icon: 'icon-deposit',
    heading: t("how_to_deposit"),
    description: t("how_to_deposit_desc_mw99"),
    en_video: "https://streamable.com/e/glp4hv",
    np_video: "https://streamable.com/e/vj2s9g",
  },
  {
    icon: 'icon-sign-in-task',
    heading: t("how_to_register"),
    description: t("how_to_register_desc_mw99"),
    en_video: "https://streamable.com/e/glht9g",
    np_video: "https://streamable.com/e/679xwm",
  },
  {
    icon: 'icon-withdrawal',
    heading: t("how_to_withdraw"),
    description: t("how_to_withdraw_desc_mw99"),
    en_video: "https://streamable.com/e/hatxqz",
    np_video: "https://streamable.com/e/2t5c1b",
  },
  {
    icon: 'icon-referral',
    heading: t("how_to_do_a_referral"),
    description: t("how_to_referral_desc_mw99"),
    en_video: "https://streamable.com/e/ixduh4",
    np_video: "https://streamable.com/e/9zozth",
  }];

const videoUrl = computed(() => {
  if (mainStore.lang == "ms") {
    return "https://www.youtube.com/embed/8wcekRTYioI?si=84xA9_qiSif-CryL"
  } else if (mainStore.lang == "en") {
    return "https://www.youtube.com/embed/K7YUwaLJC5M?si=8m6dGiLdcR8jbqQN"
  } else if (mainStore.lang == "zh") {
    return "https://www.youtube.com/embed/IgmiswyPtfs?si=8f-nvroZ7mHjF0eH"
  }
  return null
})

const onSlideChange = () => {
  pauseVideo();
};

const pauseVideo = () => {
  const iframes = document.querySelectorAll(".tutorial-iframe");
  iframes.forEach((iframe) => {
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  });
};

onMounted(() => {
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
});

const getCurrentCurrency = computed(() => {
    if (locales.value && locale.value) {
        var findCurrency = locales.value.find(e => e.code == locale.value)?.currency;
        if (findCurrency) {
            return findCurrency
        }
        return ""
    }
    return ""
})

const ew8CardData = [
  {
    image: tutorialDepositImage,
    video_MYR: 'https://www.youtube.com/embed/KxD9Xp3nqd0?si=1-kC5VPoOSSA1_5t',
    heading: t("how_to_deposit"),
    description: getCurrentCurrency.value == 'MYR' ? t("effortlessly_manage_your_deposits_at_EW8_watch_this_video_tutorial_and_learn_the_simple_steps") : t("deposit_description_ew8"),
    card: 1
  },
  {
    image: `<i class="icon-sign-in-task text-[25px] md:text-[40px] pl-2">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
        <span class="path4"></span>
        <span class="path5"></span>
        <span class="path6"></span>
        <span class="path7"></span>
        <span class="path8"></span>
        <span class="path9"></span>
        <span class="path10"></span>
        <span class="path11"></span>
        <span class="path12"></span>
        <span class="path13"></span>
      </i>`,
    video_MYR: "https://www.youtube.com/embed/NURK8fCvBZg?si=oomRRP4lzv0Szn3j",
    heading: t("how_to_register"),
    description: getCurrentCurrency.value == 'MYR' ? t("register_tutorial_description") : t("register_description_ew8"),
    card: 2
  },
  {
    image: tutorialWithdrawImage,
    video_MYR: "https://www.youtube.com/embed/12xwuCK1khg?si=bE4K3-_OhcY0t7FJ",
    heading: t("how_to_withdraw"),
    description: getCurrentCurrency.value == 'MYR' ? t("ew8_withdraw_discription") : t("withdraw_description_ew8"),
    tutorialDescription: getCurrentCurrency.value == 'MYR' ? t('learn_how_to_withdraw_after_watching_the_tutorial_video'): t("tutorial_description_ew8"),
    card: 3
  },
];

onMounted(() => {
  if (config.public.MERCHANT === 'goat77') {
    const tutorial = document.querySelector('.tutorial')
    if (!tutorial) return

    const isMobile = window.innerWidth <= 768

    tutorial.addEventListener('click', (e) => {
      const el = e.target.closest('.swiper-pagination-bullet-active')
      if (!el) return

      const paginationContainer = tutorial.querySelector('.swiper-pagination')
      if (!paginationContainer) return

      const bulletRect = el.getBoundingClientRect()
      const containerRect = paginationContainer.getBoundingClientRect()
      const scrollOffset = el.offsetLeft - (containerRect.width / 2) + (bulletRect.width / 2)

      paginationContainer.scrollTo({
        left: scrollOffset,
        behavior: 'smooth',
      })
    })
  }
})

const paginationRef = ref(null);
const pos = ref({ left: 0, x: 0 });
let isDragging = false;

const mouseDownHandler = (e) => {
  isDragging = true;
  paginationRef.value.style.cursor = 'grabbing';
  pos.value = {
    left: paginationRef.value.scrollLeft,
    x: e.clientX,
  };

  document.addEventListener('mousemove', mouseMoveHandler);
  document.addEventListener('mouseup', mouseUpHandler);
};

const mouseMoveHandler = (e) => {
  if (!isDragging) return;
  const dx = e.clientX - pos.value.x;
  paginationRef.value.scrollLeft = pos.value.left - dx;
};

const mouseUpHandler = () => {
  isDragging = false;
  paginationRef.value.style.cursor = 'grab';
  document.removeEventListener('mousemove', mouseMoveHandler);
  document.removeEventListener('mouseup', mouseUpHandler);
};

onMounted(() => {
  const el = document.querySelector('.swiper-pagination');
  if (el) {
    paginationRef.value = el;
    el.addEventListener('mousedown', mouseDownHandler);
  }
});

onBeforeUnmount(() => {
  if (paginationRef.value) {
    paginationRef.value.removeEventListener('mousedown', mouseDownHandler);
  }
});
</script>

<style scoped>
:deep(.swiper-pagination) {
  text-align: start !important;
}

@media (min-width: 768px) {
  :deep(.swiper-pagination) {
    max-width: fit-content !important;
  }
}

@media (max-width: 767px) {
  .tutorial-video {
    height: 175px !important;
  }

  :deep(.swiper-pagination) {
    bottom: 190px;
    text-align: center !important;
  }
}

:deep(.swiper-pagination-bullet-active) {
  background-color: #ffffff;
  width: 10px;
  height: 10px;
}
</style>